export default {
    // API_ENDPOINT: 'http://localhost:8080/api'
    API_ENDPOINT: 'https://petful-keith-ahmed.herokuapp.com/api'
}